import { CancelToken } from 'axios';
import ApiProvider  from '../../../../core/api/ApiProvider';
import { ActionStatusType } from '../../../../core/types/ActionStatusType';

const NavigationApi = {
  getMenuElements: async <T>(): Promise<ActionStatusType<T>> => {
    return await ApiProvider.get<ActionStatusType<T>>(
      'TopMenuModule/GetMenuElements'
    );
  },
  changeLanguage: async <T>(
    languageCode: string,
    cancelToken: CancelToken
  ): Promise<ActionStatusType<T>> => {
    return await ApiProvider.post<ActionStatusType<T>>(
      'TopMenuModule/ChangeCurrentLanguage',
      languageCode,
      cancelToken
    );
  },
};

export default NavigationApi;
